import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview } from "@/lib/analytics";

// Erfasst einen PostHog-$pageview bei jedem Routenwechsel (SPA-History).
export function AnalyticsPageview() {
  const location = useLocation();
  useEffect(() => {
    capturePageview();
  }, [location.pathname, location.search]);
  return null;
}
